<template>
    <footer class="d-flex justify-content-center align-items-center p-4 bg-fourth">
        <img src="https://www.bresciamobilita.it/assets/img/logo-mini.png">
        <h6 class="ms-4 fw-bold">
            Brescia Mobilità S.p.A. - Società Metropolitana di Mobilità
        </h6>
    </footer>
</template>

<script>
export default {
    name: 'FooterComp'
}
</script>

<style lang="scss" scoped>
    footer {
        h6 {
            font-size: 14px;
        }
    }
</style>